// extracted by mini-css-extract-plugin
export default {"block":"Home_block__vxJsa"};